import { render, staticRenderFns } from "./BaseListV2.vue?vue&type=template&id=62a100ae&scoped=true&"
import script from "./BaseListV2.vue?vue&type=script&lang=ts&setup=true&"
export * from "./BaseListV2.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./BaseListV2.vue?vue&type=style&index=0&id=62a100ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a100ae",
  null
  
)

export default component.exports